import React from "react";

interface CpSectionHeadingProps {
  eyebrow?: string;
  title?: React.ReactNode;
  lead?: React.ReactNode;
  align?: "left" | "center";
  tone?: "light" | "dark";
  maxWidth?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

/** Eyebrow + h2 + lead (CertainPath Design System `SectionHeading`). */
const CpSectionHeading: React.FC<CpSectionHeadingProps> = ({
  eyebrow,
  title,
  lead,
  align = "left",
  tone = "light",
  maxWidth = "var(--measure-lead)",
  children,
  style,
}) => {
  const onDark = tone === "dark";
  return (
    <header
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--space-3)",
        alignItems: align === "center" ? "center" : "flex-start",
        textAlign: align,
        fontFamily: "var(--font-sans)",
        ...style,
      }}
    >
      {eyebrow && (
        <span
          style={{
            fontSize: "var(--text-eyebrow)",
            fontWeight: 800,
            letterSpacing: "var(--tracking-eyebrow)",
            textTransform: "uppercase",
            color: onDark ? "var(--gold-400)" : "var(--red-500)",
          }}
        >
          {eyebrow}
        </span>
      )}
      {title && (
        <h2
          style={{
            margin: 0,
            fontSize: "var(--text-h1)",
            lineHeight: "var(--leading-snug)",
            letterSpacing: "var(--tracking-display)",
            fontWeight: 800,
            color: onDark ? "var(--cream-100)" : "var(--ink-500)",
            maxWidth: "18ch",
          }}
        >
          {title}
        </h2>
      )}
      {lead && (
        <p
          style={{
            margin: 0,
            maxWidth,
            fontSize: "var(--text-lead)",
            lineHeight: "var(--leading-body)",
            color: onDark ? "var(--text-on-dark-muted)" : "var(--text-muted)",
          }}
        >
          {lead}
        </p>
      )}
      {children}
    </header>
  );
};

export default CpSectionHeading;
